import { render, staticRenderFns } from "./bigData.vue?vue&type=template&id=28880501&scoped=true&"
import script from "./bigData.vue?vue&type=script&lang=js&"
export * from "./bigData.vue?vue&type=script&lang=js&"
import style0 from "./bigData.vue?vue&type=style&index=0&id=28880501&lang=scss&scoped=true&"
import style1 from "./bigData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28880501",
  null
  
)

export default component.exports